import React, { useState, useEffect, useCallback, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Dropdown, Modal, Button } from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import Spinner from "../components/Common/Spinner";
import Pagination from "../components/Pagination";
import {
  createSubadmins,
  deleteSubadmins,
  getSubadmins,
  getUserRole,
  updateSubadmins,
  resetSubadminPassword,
} from "../../services/UserServices/UserService";
import { FiEye, FiEyeOff } from "react-icons/fi";

const CreateAdmin = () => {
  const [adminUsers, setAdminUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showPassowordModal, setShowPassowordModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [role, setRole] = useState([]);
  // Filter & Search states
  const [searchText, setSearchText] = useState("");
  const [roleFilter, setRoleFilter] = useState("");

  const location = useLocation();
  const navigate = useNavigate();
  // Pagination states
  const [currentPage, setCurrentPage] = useState(
    location.state?.currentPage ?? 0
  );
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  // Confirmation modal state
  const [confirmState, setConfirmState] = useState({
    show: false,
    action: null,
    id: null,
    status: null,
    message: "",
  });

  const [submit, setSubmit] = useState(false);

  const svgDots = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );

  // Mocking data fetching logic
  const fetchAdminUsers = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getSubadmins(currentPage, 10);
      setAdminUsers(res?.data?.data?.admins || []);
      setTotalItems(res?.data?.data?.total);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load admin users");
    } finally {
      setLoading(false);
    }
  }, [searchText, roleFilter, currentPage]);

  useEffect(() => {
    fetchAdminUsers();
  }, [fetchAdminUsers]);

  const fetchRoles = async () => {
    try {
      const res = await getUserRole(0, 20);
      console.log(res?.data?.data?.roles);
      setRole(res?.data?.data?.roles);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchRoles();
  }, []);

  useEffect(() => {
    if (currentPage !== undefined) {
      navigate(".", {
        replace: true,
        state: { ...location.state, currentPage },
      });
    }
  }, [currentPage]);

  // Reset page index on filter updates
  const isInitialMount = useRef(true);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    setCurrentPage(0);
  }, [searchText, roleFilter]);

  const handleClearFilters = () => {
    setSearchText("");
    setRoleFilter("");
  };

  const isFilterActive = searchText || roleFilter;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // Open Edit/Create modal
  const openModal = (user = null) => {
    setSelectedUser(user);
    setShowModal(true);
  };

  const openPasswordModal = (user = null) => {
    setSelectedUser(user);
    setShowPassowordModal(true);
  };
  const handleClosePassowordModal = () => {
    setShowPassowordModal(false);
    setSelectedUser(null);
    setShowPassword(false);
    setShowPassword1(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedUser(null);
  };

  // Form Validation Schema
  const UserSchema = Yup.object().shape({
    name: Yup.string().trim().required("Name is required"),
    email: Yup.string().trim()
      .email("Invalid email format")
      .required("Email is required"),
    roleId: Yup.string().required("Please assign a role"),
   
    password: selectedUser
    ? Yup.string().nullable()
    : Yup.string()
        .required("Password is required")
        .min(6, "Minimum 6 characters"),
  });

  const ResetPasswordSchema = Yup.object().shape({
    newPassword: Yup.string()
      .required("New password is required")
      .min(6, "Minimum 6 characters"),

    confirmPassword: Yup.string()
      .required("Confirm password is required")
      .oneOf([Yup.ref("newPassword")], "Passwords must match"),
  });

  const handleSubmit = async (values, { resetForm }) => {
    setSubmit(true);
    try {
      // Create payload without the 'isEdit' helper flag
      const payload = {
        name: values.name,
        email: values.email,
        roleId: values.roleId,
        ...(values.password && { password: values.password }),
      };

      if (selectedUser) {
        const payload = {
          ...values,
          id: selectedUser._id,
        };
        await updateSubadmins(payload);
        console.log("Updating User API Payload:", {
          id: selectedUser._id,
          ...payload,
        });
        toast.success("User updated successfully  ");
      } else {
        await createSubadmins(payload);
        console.log("Creating User API Payload:", payload);
        toast.success("New admin user created successfully  ");
        resetForm();
      }
      handleCloseModal();
      fetchAdminUsers();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to save user");
    } finally {
      setSubmit(false);
    }
  };
  const handlePasswordSubmit = async (values, { resetForm }) => {
    setSubmit(true);
    try {
      // Create payload without the 'isEdit' helper flag
      const payload = {
        subAdminId: values.subAdminId,
        newPassword: values.newPassword,
      };

      await resetSubadminPassword(payload);

      toast.success("Password updated successfully  ");

      handleClosePassowordModal();

      fetchAdminUsers();
    } catch (error) {
      toast.error("Failed to save passowrd");
    } finally {
      setSubmit(false);
    }
  };

  // Trigger Action Confirmation Modals
  const triggerConfirm = (action, id, status = null) => {
    let message = "";
    if (action === "delete") {
      message =
        "Are you sure you want to delete this admin? This action cannot be undone.";
    } else if (action === "status") {
      message = `Are you sure you want to change this user's status to ${status.toLowerCase()}?`;
    }
    setConfirmState({ show: true, action, id, status, message });
  };

  const handleDelete = async (id) => {
    try {
      await deleteSubadmins(id);
      toast.success("User deleted successfully  ");
      fetchAdminUsers();
      setConfirmState({
        show: false,
        action: null,
        id: null,
        status: null,
        message: "",
      });
    } catch (error) {
      toast.error("Failed to delete user");
    } finally {
      setSubmit(false);
    }
  };
  const confirmActionHandler = () => {
    const { action, status } = confirmState;
    if (action === "delete") {
      handleDelete(confirmState.id);
    } else if (action === "status") {
      toast.success(`User status updated to ${status}  `);
    }
    setConfirmState({
      show: false,
      action: null,
      id: null,
      status: null,
      message: "",
    });
  };

  return (
    <div className="container mt-4">
      {/* Header View */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h1 style={{ color: "#E5484D" }}>Sub Admins</h1>
        <button
          onClick={() => openModal(null)}
          className="btn btn-sm text-white d-flex align-items-center gap-2 shadow-sm px-3 py-2"
          style={{
            backgroundColor: "#E5484D",
            borderRadius: "0.5rem",
            border: "none",
          }}
        >
          Create Admin User
        </button>
      </div>

      {/* Filters/Controls Layout */}
      {/* <div className="pb-2 d-flex flex-wrap justify-content-between gap-2 align-items-center mb-4">
        <div className="flex-grow-1" style={{ minWidth: "250px" }}>
          <label className="form-label mb-1" style={{ fontSize: "12px" }}>Search Users</label>
          <input
            type="text"
            className="form-control"
            placeholder="Search by name or email..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ borderRadius: "0.5rem", borderColor: "#E5484D" }}
          />
        </div>

        <div>
          <label className="form-label mb-1" style={{ fontSize: "12px" }}>Filter by Role</label>
          <select
            className="form-control"
            value={roleFilter}
            style={{ borderRadius: "0.5rem", borderColor: "#E5484D", minWidth: "200px" }}
            onChange={(e) => setRoleFilter(e.target.value)}
          >
            <option value="">All Roles</option>
            {MOCK_ROLES.map((role) => (
              <option key={role._id} value={role._id}>
                {role.roleName}
              </option>
            ))}
          </select>
        </div>

        {isFilterActive && (
          <div className="d-flex flex-column">
            <label className="form-label mb-1" style={{ fontSize: "12px" }}>&nbsp;</label>
            <button
              className="btn btn-outline-danger"
              onClick={handleClearFilters}
              style={{ borderRadius: "0.5rem" }}
            >
              Clear
            </button>
          </div>
        )}
      </div> */}

      {/* Main Admin Users Table */}
      {loading ? (
        <Spinner />
      ) : (
        <div className="table-responsive">
          <table className="table table-striped align-middle shadow-sm">
            <thead className="table-light">
              <tr>
                <th>Sr No.</th>
                <th>Name</th>
                <th>Email</th>
                <th>Assigned Role</th>

                <th>Created At</th>
                <th style={{ textAlign: "center" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {adminUsers.length > 0 ? (
                adminUsers.map((user, index) => (
                  <tr key={user._id || index}>
                    <td>{currentPage * itemsPerPage + index + 1}</td>
                    <td className="fw-semibold">{user.name}</td>
                    <td>{user.email}</td>
                    <td>
                      <span className="badge bg-secondary">
                        {user?.role?.name}
                      </span>
                    </td>

                    <td>{new Date(user.createdAt).toLocaleDateString()}</td>
                    <td style={{ textAlign: "center" }}>
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="light"
                          style={{ padding: "4px 8px" }}
                        >
                          {svgDots}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => openModal(user)}>
                            Edit User & Role
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => openPasswordModal(user)}
                          >
                            Reset Password
                          </Dropdown.Item>
                          {/* <Dropdown.Item
                            onClick={() =>
                              triggerConfirm(
                                "status",
                                user._id,
                                user.status === "Active" ? "Inactive" : "Active"
                              )
                            }
                          >
                            Mark As {user.status === "Active" ? "Inactive" : "Active"}
                          </Dropdown.Item> */}
                          <Dropdown.Item
                            onClick={() => triggerConfirm("delete", user._id)}
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No users found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Table Footer / Pagination */}
      <div className="card-footer clearfix mt-3">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            {totalPages > 0 && (
              <Pagination
                pageCount={totalPages}
                pageValue={currentPage}
                setPage={setCurrentPage}
              />
            )}
          </div>
        </div>
      </div>

      {/* Add / Edit Admin User Modal */}
      <Modal
        size="lg"
        backgroundColor="#FFE4E7"
        show={showModal}
        onHide={handleCloseModal}
        centered
      >
        <Modal.Header closeButton style={{ backgroundColor: "#FFE4E6" }}>
          <Modal.Title style={{ color: "#E5484D" }}>
            {selectedUser ? "Edit Subadmin  " : "Create Subadmin  "}
          </Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{
            name: selectedUser ? selectedUser.name : "",
            email: selectedUser ? selectedUser.email : "",
            roleId: selectedUser ? selectedUser.role?._id : "",
            password: "",
          }}
          enableReinitialize
          validationSchema={UserSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched }) => (
            <FormikForm >
              <Modal.Body>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-semibold">Full Name</label>
                    <Field
                      name="name"
                      placeholder="e.g., Jane Doe"
                  className={`form-control custom-input ${
    errors.name && touched.name ? "input-error" : ""
  }`}
                    />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="text-danger small mt-1"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-semibold">
                      Email Address
                    </label>
                    <Field
                      type="email"
                      autoComplete="off"
                      name="email"
                      placeholder="jane@example.com"
                      className={`form-control  custom-input${errors.email && touched.email ? "input-error" : ""}`}
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="text-danger small mt-1"
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">Assign Role</label>
                  <Field
                    as="select"
                    name="roleId"
                    className={`form-select ${errors.roleId && touched.roleId ? "is-invalid" : ""}`}
                  >
                    <option value="">-- Select a Role --</option>
                    {role.map((role, index) => (
                      <option key={index} value={role._id}>
                        {role.name}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage
                    name="roleId"
                    component="div"
                    className="text-danger small mt-1"
                  />
                </div>

                {selectedUser ? (
                  ""
                ) : (
                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      {selectedUser ? "Update Password (Optional)" : "Password"}
                    </label>

                    <div className="position-relative">
                      <Field
                        type={showPassword ? "text" : "password"}
                        name="password"
                          autoComplete="new-password"
                          onKeyDown={(e) => {
    if (e.key === " ") {
      e.preventDefault();
    }
  }}
                        placeholder={
                          selectedUser
                            ? "Leave blank to keep current password"
                            : "Enter a secure password"
                        }
                        className={`form-control  custom-input ${
                          errors.password && touched.password
                            ? "input-error"
                            : ""
                        }`}
                      />
                      <button
                        type="button"
                        className="btn position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FiEyeOff /> : <FiEye />}
                      </button>
                    </div>

                    <ErrorMessage
                      name="password"
                      component="div"
                      className="text-danger small mt-1"
                    />
                  </div>
                )}
              </Modal.Body>
              <Modal.Footer style={{ backgroundColor: "#FFE4E6" }}>
                <Button variant="secondary" onClick={handleCloseModal}>
                  Cancel
                </Button>
                <Button
                  type="submit"
                  style={{
                    backgroundColor: "#E5484D",
                    borderColor: "#E5484D",
                    color: "white",
                  }}
                  disabled={submit}
                >
                  {submit ? "Saving..." : "Save User"}
                </Button>
              </Modal.Footer>
            </FormikForm>
          )}
        </Formik>
      </Modal>

      <Modal
        size="lg"
        backgroundColor="#FFE4E7"
        show={showPassowordModal}
        onHide={handleClosePassowordModal}
        centered
      >
        <Modal.Header closeButton style={{ backgroundColor: "#FFE4E6" }}>
          <Modal.Title style={{ color: "#E5484D" }}>
            {selectedUser ? "Change Password Subadmin  " : "  "}
          </Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{
            newPassword: "",
            confirmPassword: "",
            subAdminId: selectedUser?._id,
          }}
          enableReinitialize
          validationSchema={ResetPasswordSchema}
          onSubmit={handlePasswordSubmit}
        >
          {({ errors, touched }) => (
            <FormikForm>
              <Modal.Body>
                <div className="mb-3">
                  <label className="form-label fw-semibold">New Password</label>

                  <div className="position-relative">
                    <Field
                      type={showPassword ? "text" : "password"}
                      name="newPassword"
                      placeholder="Enter a secure password"
                          onKeyDown={(e) => {
    if (e.key === " ") {
      e.preventDefault();
    }
  }}
                      className={`form-control  custom-input ${
                        errors.newPassword && touched.newPassword
                          ? "input-error"
                          : ""
                      }`}
                    />
                    <button
                      type="button"
                      className="btn position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <FiEyeOff /> : <FiEye />}
                    </button>
                  </div>

                  <ErrorMessage
                    name="newPassword"
                    component="div"
                    className="text-danger small mt-1"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    Confirm Password
                  </label>

                  <div className="position-relative">
                    <Field
                      type={showPassword1 ? "text" : "password"}
                      name="confirmPassword"
                      placeholder="Enter a secure password" 
                          onKeyDown={(e) => {
    if (e.key === " ") {
      e.preventDefault();
    }
  }}
                      className={`form-control custom-input ${
                        errors.confirmPassword && touched.confirmPassword
                          ? "input-error"
                          : ""
                      }`}
                    />
                    <button
                      type="button"
                      className="btn position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent"
                      onClick={() => setShowPassword1(!showPassword1)}
                    >
                      {showPassword1 ? <FiEyeOff /> : <FiEye />}
                    </button>
                  </div>

                  <ErrorMessage
                    name="confirmPassword"
                    component="div"
                    className="text-danger small mt-1"
                  />
                </div>
              </Modal.Body>
              <Modal.Footer style={{ backgroundColor: "#FFE4E6" }}>
                <Button variant="secondary" onClick={handleClosePassowordModal}>
                  Cancel
                </Button>
                <Button
                  type="submit"
                  style={{
                    backgroundColor: "#E5484D",
                    borderColor: "#E5484D",
                    color: "white",
                  }}
                  disabled={submit}
                >
                  {submit ? "reseting..." : "Reset Password"}
                </Button>
              </Modal.Footer>
            </FormikForm>
          )}
        </Formik>
      </Modal>

      {/* Global Confirmation Modal */}
      <Modal
        show={confirmState.show}
        onHide={() => setConfirmState({ ...confirmState, show: false })}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm System Action</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0 fs-5">{confirmState.message}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setConfirmState({ ...confirmState, show: false })}
          >
            Cancel
          </Button>
          <Button
            variant={confirmState.action === "delete" ? "danger" : "primary"}
            style={
              confirmState.action !== "delete"
                ? { backgroundColor: "#E5484D", borderColor: "#E5484D" }
                : {}
            }
            onClick={confirmActionHandler}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CreateAdmin;
